import React from "react";
import { css } from "@emotion/react";
import { Label, Font } from "@moneyforward/mfx_biz_react_components";
import { emailValidation } from "@/components/validations";
import { FormErrorMessage, FormTextField } from "@/components/molecules";

type Props = {
  itemName?: string;
  name: string;
  labelRequired?: boolean; // default false / バリデーション内容によらず、必須ラベル付与を制御する
};

const emailFormField = (
  props: Props,
  ref: React.ForwardedRef<HTMLInputElement>
) => {
  const { labelRequired = false } = props;
  return (
    <div css={container}>
      <div css={labelWrapper}>
        <Font variant="m" component="p">
          {props.itemName ? props.itemName : <>{"メールアドレス"}</>}{" "}
          {labelRequired && <Label variant="required" />}
        </Font>
      </div>
      <div css={inputWrapper}>
        <FormTextField
          name={props.name}
          placeholder={"例）xxxxxx@example.com"}
          registerOptions={{
            validate: emailValidation,
          }}
          ref={ref}
        />
        <div css={errorWrapper}>
          <FormErrorMessage name={props.name} />
        </div>
      </div>
    </div>
  );
};

export const EmailFormField = React.forwardRef(emailFormField);

const container = css({
  display: "flex",
});

const labelWrapper = css({
  width: "200px",
  marginRight: "15px",
  paddingTop: "10px",
  paddingBottom: "4px",
});

const inputWrapper = css({
  width: "100%",
});

const errorWrapper = css({
  flex: 1,
});
